
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface NotificationTypeDropdownProps {
  type: string;
  onValueChange: (value: string) => void;
  required?: boolean;
  error?: string;
}

const NotificationTypeDropdown = ({ 
  type, 
  onValueChange, 
  required = false,
  error
}: NotificationTypeDropdownProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="type" className="flex">
        Type melding
        {required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      <Select
        name="type"
        value={type}
        onValueChange={onValueChange}
        required={required}
      >
        <SelectTrigger 
          id="type"
          className={error ? "border-red-500" : ""}
        >
          <SelectValue placeholder="Selecteer type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="nalevering">Nalevering</SelectItem>
          <SelectItem value="nv_artikel">NV-Artikel</SelectItem>
          <SelectItem value="kleur_vraag">Kleur vraag</SelectItem>
          <SelectItem value="deellevering">Deellevering</SelectItem>
          <SelectItem value="geannuleerd">Geannuleerd</SelectItem>
          <SelectItem value="extern_transport">Extern transport</SelectItem>
          <SelectItem value="order_ridderkerk">Order vanuit Ridderkerk</SelectItem>
          <SelectItem value="anders">Anders</SelectItem>
        </SelectContent>
      </Select>
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default NotificationTypeDropdown;
